<template lang="pug">
  .blog-social-networks
    .social-section(v-if="variant === 'stacked'")
      p.f-primary.semi-bold.share-title.mb-75m SHARE
      share-network.social-icons.f-primary.semi-bold(
        network="twitter"
        :url="contentUrl"
        :title="title"
        twitter-user="madisonreedllb"
        aria-label="Share on Twitter"
      )
        span.icon-twitter.max-at-tweak(aria-hidden="true")
        span.social-text Twitter
      share-network.social-icons.f-primary.semi-bold(
        network="facebook"
        :url="contentUrl"
        :title="title"
        aria-label="Share on Facebook"
      )
        span.icon-facebook.max-at-tweak(aria-hidden="true")
        span.social-text Facebook
      share-network.social-icons.f-primary.semi-bold(
        network="pinterest"
        :url="contentUrl"
        :title="title"
        :media="contentImageUrl"
        aria-label="Share on Pinterest"
      )
        span.icon-pinterest.max-at-tweak(aria-hidden="true")
        span.social-text Pinterest
      a.social-icons.f-primary.semi-bold(:href="emailHref" aria-label="Share via Email")
        span.email-icon.max-at-tweak(aria-hidden="true")
        span.social-text Email
    .social-section.inline(v-else-if="variant === 'inline'")
      share-network.social-icons.f-primary.semi-bold(
        network="twitter"
        :url="contentUrl"
        :title="title"
        twitter-user="madisonreedllb"
        aria-label="Share on Twitter"
      )
        span.icon-twitter.max-at-tweak(aria-hidden="true")
      share-network.social-icons.f-primary.semi-bold.ml-50m(
        network="facebook"
        :url="contentUrl"
        :title="title"
        aria-label="Share on Facebook"
      )
        span.icon-facebook.max-at-tweak(aria-hidden="true")
      share-network.social-icons.f-primary.semi-bold.ml-50m(
        network="pinterest"
        :url="contentUrl"
        :title="title"
        :media="contentImageUrl"
        aria-label="Share on Pinterest"
      )
        span.icon-pinterest.max-at-tweak(aria-hidden="true")
      a.social-icons.f-primary.semi-bold.ml-50m.email-button(:href="emailHref" aria-label="Share via Email")
        span.email-icon.max-at-tweak(aria-hidden="true")
</template>

<script>
  export default {
    name: "BlogSocialNetworks",

    props: {
      contentUrl: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      contentImageUrl: {
        type: String,
        default: ''
      },
      variant: {
        type: String,
        default: 'stacked',
        validator(value) {
          return ['stacked', 'inline'].includes(value);
        }
      }
    },

    computed: {
      emailHref() {
        return `mailto:?subject=Madison Reed - ${this.title}&body=${this.title} ${this.contentUrl} via Madison Reed`;
      }
    }
  };
</script>

<style lang="stylus">
.social-section
  display flex
  flex-direction column
  margin-top 10px
  margin-bottom 5px

  &.inline
    display flex
    flex-direction row
    align-items center

    .social-icons
      padding 0.5em
      border-radius 2rem
      &.email-button
        padding 0.5em 0.7em

  @media mq-mobile
    margin-top 5%
    margin-bottom 6%

  .share-title
    color #595959

  .social-icons
    display flex
    margin-bottom 0.5rem
    border-radius 8px
    background-color #ffffff
    color #595959
    border 1.5px solid #DBDBDC
    padding 0.5em
    &:hover
      border 1.5px solid #595959


    &:before
      margin-right 0.3em

  .social-text
    margin auto

  .email-icon
    font-family fontello !important

    &:before
      content icon-email !important

  .facebook-icon
    font-family fontello !important

    &:before
      content icon-facebook !important

  .twitter-icon
    font-family fontello !important

    &:before
      content icon-twitter !important

  .pinterest-icon
    font-family fontello !important

    &:before
      content icon-pinterest !important
</style>
